import axios from "axios";


export const LOGIN_URL = "seltec/auth/loginuser";
export const REGISTER_URL = "seltec/api/auth/register";
export const REQUEST_PASSWORD_URL = "seltec/api/auth/forgot-password";

export const ME_URL = "api/me";

export function login(username, password) {
  return axios.post(LOGIN_URL, JSON.stringify({ "Username": username, "Password": password }));
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  //console.log(1);
  // Authorization head should be fulfilled in interceptor.
   return axios.get(ME_URL);
}
